/**
 * 用户验证模块
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BaseAntModules, EnhanceClickDirective, FlIconComponent } from '@common';
import { LoginComponent } from './login/login.component';
import { AuthService } from '@shared/service/auth.service';
import { AuthRouteModule } from './auth-routing.module';
import { CourseService } from '@shared/service/course.service';
import { ProfileComponent } from './profile/profile.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { ProfileGuardGuard } from '@shared/guard/profile-guard.guard';
import { UserManageComponent } from './user-manage/user-manage.component';
import { ManagerGuardGuard } from '@shared/guard/manager-guard.guard';
import { OAuth2Service } from '@shared/service/OAuth.service';
import { ClassroomService } from '@shared/service/classroom.service';
import { EditTeacherInfoComponent } from './user-manage/edit-teacher-info/edit-teacher-info.component';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { AtlasManageComponent } from './atlas-manage/atlas-manage.component';
import { AtlasSchoolComponent } from './atlas-manage/components/atlas-school/atlas-school.component';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { EditLoginComponent } from '@app/auth/edit-login/edit-login.component';
import { ImageCropComponent } from '@app/auth/edit-login/components/image-crop/image-crop.component';
import { QuestionModule } from '@shared/question/question.module';
import { BindPhoneComponent } from '@shared/component/bind-phone/bind-phone.component';
import { MaskAccountPipe } from '@shared/pipes/mask-account.pipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    QuestionModule,
    ReactiveFormsModule,
    AuthRouteModule,
    BaseAntModules,
    NzDrawerModule,
    NzDividerModule,
    NzDatePickerModule,
    NzLayoutModule,
    NzTabsModule,
    NzSwitchModule,
    NzAlertModule,
    NzListModule,
    NzTypographyModule,
    NzTagModule,
    NzTreeModule,
    ImageCropComponent,
    FlIconComponent,
    EnhanceClickDirective,
    BindPhoneComponent,
    MaskAccountPipe,
  ],
  declarations: [
    LoginComponent,
    ProfileComponent,
    LoginPageComponent,
    UserManageComponent,
    EditTeacherInfoComponent,
    AtlasManageComponent,
    AtlasSchoolComponent,
    EditLoginComponent,
  ],
  providers: [AuthService, OAuth2Service, CourseService, ClassroomService, ProfileGuardGuard, ManagerGuardGuard],
  exports: [LoginComponent],
})
export class AuthModule {}
